"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledEffectIcon = exports.StyledEffectElement = exports.StyledOptionContainer = exports.StyledColorContainer = exports.StyledEffectsContainer = exports.StyledEffectOptionsContainer = exports.StyledTitle = exports.StyledColumnContainer = void 0;
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const { rem } = ui_common_components_1.utils;
exports.StyledColumnContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  cursor: pointer;

  ${({ theme }) => (0, styled_components_1.css) `
    transition: ${theme.Transition.Timing.Out};
    padding: ${rem(theme.Spacing.Size.Small)} ${rem(theme.Spacing.Size.XSmall)};
    gap: ${rem(theme.Spacing.Size.XSmall)};
  `}
`;
exports.StyledTitle = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XXSmall)};
`;
exports.StyledEffectOptionsContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XXSmall)};
`;
exports.StyledEffectsContainer = styled_components_1.default.div `
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;
exports.StyledColorContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
const EffectElementSize = 58;
exports.StyledOptionContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
  width: 100%;
  gap: ${({ theme }) => rem(theme.Spacing.Size.Small)};
`;
exports.StyledEffectElement = styled_components_1.default.div `
  cursor: pointer;
  display: flex;
  height: ${rem(EffectElementSize)};
  justify-content: center;
  align-items: center;
  position: relative;
  text-transform: capitalize;
  width: ${rem(EffectElementSize)};
  ${({ theme, active }) => (0, styled_components_1.css) `
    color: ${theme.Color.System.Primary};
    background-color: ${theme.Color.Neutrals.Paper};
    font-weight: ${theme.Typography.FontWeight.Bold};
    font-family: ${theme.Typography.FontFamily};
    border-radius: ${rem(theme.Border.Radius.Medium)};
    border: ${rem(theme.Border.Size.Large)} solid
      ${active ? theme.Color.System.Primary : theme.Color.Neutrals.Border};
  `}
`;
exports.StyledEffectIcon = styled_components_1.default.span `
  display: flex;
  & i {
    width: 100%;
    height: 45%;
    svg {
      width: ${({ theme }) => rem(theme.Spacing.Size.XXLarge)};
      height: ${({ theme }) => rem(theme.Spacing.Size.Large)};
    }
  }
`;
//# sourceMappingURL=Effects.style.js.map